import { useState } from "react";
import Button from "../Reusable/Button";
import toggleInputType from "../../assets/toggleInputType.png";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePostHook from "../../customHooks/usePostHook";
import Card from "../Reusable/Card";
import SwitchButton from "../Reusable/SwitchButton";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import ApiDocsInterface from "../ApiDocsInterface/ApiDocsInterface";

const APIIntegration = (props: any) => {
  const { data: apiData, refetch } = useGetHook({
    queryKey: [`merchant-api`],
    url: APIS.API_KEY,
    params: {},
  });

  const { mutateAsync: createNewAPI, isPostLoading } = usePostHook({
    queryKey: ["merchant-api"],
    navigateURL: "",
  });

  const { mutateAsync: toggleIsActive } = usePostHook({
    queryKey: ["merchant-api"],
    navigateURL: "",
  });

  const { mutateAsync: toggleIsTest } = usePostHook({
    queryKey: ["merchant-api"],
    navigateURL: "",
  });

  const handleCreateNewAPI = async (values: any) => {
    const url = APIS.API_KEY;
    let formData = {};
    try {
      await createNewAPI({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };

  const handleToggleIsActive = async (values: any) => {
    const url = `${APIS.API_KEY}toggle-is-active/`;
    let formData = {};
    try {
      await toggleIsActive({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };

  const handleToggleIsTest = async (values: any) => {
    const url = `${APIS.API_KEY}toggle-is-test/`;
    let formData = {};
    try {
      await toggleIsTest({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };
  const [isPasswordType, setIsPasswordType] = useState(true);
  const [isPasswordType2, setIsPasswordType2] = useState(true);
  const [showApiKey, setShowApiKey] = useState(false);
  return (
    <>

    {showApiKey ?
      <Card title={"API KEY"} onClick={() => setShowApiKey(false)}>
        <div className={tw`m-2 relative`}>
          <button
            onClick={() => setShowApiKey(false)}
            className={tw`text-sm text-red-600 hover:underline mb-4 absolute right-0 bottom-0`}
          >
            Hide 
          </button>
          <div className={tw`w-full my-2 text-left relative mt-4`}>
            <div className={tw`relative`}>
              <p>Access Key</p>
              <input
                defaultValue={apiData?.access_key}
                type={isPasswordType ? "password" : "text"}
                disabled={true}
                className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
              />
              <img
                src={toggleInputType}
                onClick={() => setIsPasswordType(!isPasswordType)}
                alt="toogle input type"
                className={tw`absolute bottom-[10px] right-[10px] cursor-pointer`}
              />
            </div>
            <div className={tw`relative mt-6`}>
              <p>Secret Key</p>
              <input
                defaultValue={apiData?.secret_key}
                type={isPasswordType2 ? "password" : "text"}
                disabled={true}
                className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
              />
              <img
                src={toggleInputType}
                onClick={() => setIsPasswordType2(!isPasswordType2)}
                alt="toogle input type"
                className={tw`absolute bottom-[10px] right-[10px] cursor-pointer`}
              />
            </div>
          </div>
          <div className={tw`flex gap-x-8 mt-4`}>
            <div className={tw`flex gap-x-8`}>
              <p>Test Mode</p>
              <SwitchButton
                value={apiData?.is_active}
                onChange={handleToggleIsActive}
              />
            </div>
            <div className={tw`flex gap-x-8`}>
              <p>Active Status</p>
              <SwitchButton
                value={apiData?.is_test}
                onChange={handleToggleIsTest}
              />
            </div>
          </div>
          <div className={tw`w-full flex justify-between`}>
            <div className={tw`w-[150px] mt-6`}>
              <Button
                label={"Generate New Key"}
                onClick={handleCreateNewAPI}
                isLoading={isPostLoading}
              />
            </div>
          </div>
        </div>
      </Card> : <div>
        <Button
          label={"Show API Key"}
          onClick={() => setShowApiKey(true)}
          isLoading={false}
        />
      </div>
      }
    </>
  );
};

export default APIIntegration;
